import {Navbar, Nav, Container} from 'react-bootstrap';
import React from "react";
import {isUserAuthorized} from "../Utils/Security";
import Logout from "./Logout";

function NavigationBar(props) {

    const renderMenu = () => {
        if (isUserAuthorized() === true) {
            return <Container className="ml-0">
                <Navbar.Toggle aria-controls='responsive-navbar-nav'/>
                <Navbar.Collapse id='responsive-navbar-nav'>
                    <Nav>
                        <Nav.Link href="/dashboard">Dashboard</Nav.Link>
                        <Nav.Link href="/upload">Upload</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
                <Logout setAuthenticated={props.setAuthenticated}/>
            </Container>
        } else {
            return null;
        }

    };

    return (
        <Navbar collapseOnSelect fixed='top' expand='sm' bg="dark" variant="dark">
            <Navbar.Brand href="/home">Home</Navbar.Brand>
            {renderMenu()}
        </Navbar>
    )
}
export default NavigationBar;
